import $ from 'jquery';

var menu                         = $( '.header__menu, .header__mobile_menu, .menu-reveal-overlay, .header__foreground_top_cross, .header__foreground_top_hamburger' );
var header__foreground_top       = $( '.header__foreground_top' );
var header__foreground_top_right = $( '.header__foreground_top_right' );
$( '.header__foreground_top_toggle-menu, .menu-reveal-overlay' ).on( 'click', function () {
	if ( Foundation.MediaQuery.atLeast( 'large' ) && $( 'body' ).hasClass( 'home' ) ) {
		menu = $( '.header__menu, .header__mobile_menu, .menu-reveal-overlay' );
	}
	header__foreground_top_right.toggleClass( 'menu-active' );
	header__foreground_top.toggleClass( 'white' );
	menu.toggle();
	Foundation.reInit( 'drilldown' );
} );

// Check the current language set by WPML
var currentLanguage = document.documentElement.lang ?? 'nl-NL';

var translations = {
	'en-US': 'Back',
	'nl-NL': 'Terug'
};

var backButton = document.querySelector( '.js-drilldown-back a' );

if ( backButton && translations[ currentLanguage ] ) {
	backButton.textContent = translations[ currentLanguage ];
}